module.exports = __webpack_public_path__ + "img/minimize_white.5c8a84e0.svg";